import React from "react"
import Grid from "semantic-ui-react/dist/es/collections/Grid/Grid"
import "./Summary.css"
import SummaryBody from "./SummaryBody"
import SummaryFooter from "./SummaryFooter"
import SummaryHeader from "./SummaryHeader"

const Summary = ({ children, style, ...rest }) => {
  return (
    <Grid stackable style={{ ...style, marginBottom: "0" }} {...rest}>
      {children}
    </Grid>
  )
}

Summary.Header = SummaryHeader
Summary.Body = SummaryBody
Summary.Footer = SummaryFooter

export default Summary
